import React from 'react';

import AnchorActivityItem from './ActivityItem/AnchorActivityItem/AnchorActivityItem';
import ArchiveableItem from './ActivityItem/ArchiveableItem/ArchiveableItem';
import CreatedItem from './ActivityItem/CreatedItem/CreatedItem';
import DisplayNewItem from './ActivityItem/DisplayNewItem/DisplayNewItem';
import MarkedItem from './ActivityItem/MarkedItem/MarkedItem';
import ModifiedItem from './ActivityItem/ModifiedItem/ModifiedItem';
import MovedItem from './ActivityItem/MovedItem/MovedItem';
import StarredItem from './ActivityItem/StarredItem/StarredItem';
import TaggedItem from './ActivityItem/TaggedItem/TaggedItem';

import { INBOX_EMAIL_TYPE } from '../../Inbox2/Config/inbox.config';

export const ACTIVITIES_COMPONENTS = {
  commented: ({ id, userLabel, actionType, document }) => (
    <AnchorActivityItem
      key={id}
      userLabel={userLabel}
      actionTypeLabel={` ${actionType} on`}
      filename={document.origin}
    />
  ),
  uploaded: ({ id, actionType, document }) => (
    <AnchorActivityItem key={id} actionTypeLabel={` ${actionType}`} filename={document.origin} />
  ),
  restored: ({ id, actionType, document }) => (
    <AnchorActivityItem
      key={id}
      actionTypeLabel={` ${actionType}`}
      filename={document.linkSubject}
    />
  ),
  created: ({ id, document, title, actionType, new: newValue, tagType, tagTypeId }) => (
    <CreatedItem
      key={id}
      actionType={actionType}
      title={title}
      tagType={tagType}
      tagTypeId={tagTypeId}
      newValue={newValue}
      filename={document.origin}
    />
  ),
  deleted: ({ id, actionType, linkType, document, title, onClickFile }) => (
    <ArchiveableItem
      key={id}
      actionTypeLabel={
        title?.indexOf('permanently') > -1
          ? title
          : `${actionType} ${title?.indexOf('draft') > -1 ? 'a draft' : 'a document'}`
      }
      title={title}
      useTitle={linkType === INBOX_EMAIL_TYPE}
      filename={document.origin}
      isDeleted={document.isDeleted}
      onClickFile={onClickFile}
    />
  ),
  copy: ({ id, title, document, onClickFile }) => (
    <ArchiveableItem
      key={id}
      actionTypeLabel={`${title}`}
      filename={document.linkSubject}
      onClickFile={onClickFile}
    />
  ),
  moved: ({ id, document, actionType, new: newValue, onClickFile }) => (
    <MovedItem
      key={id}
      actionType={actionType}
      folderName={newValue}
      filename={document.origin}
      onClickFile={onClickFile}
    />
  ),
  tagged: ({ id, document, title, linkType, old: oldValue, new: newValue }) => (
    <TaggedItem
      key={id}
      linkType={linkType}
      title={title}
      useTitle={linkType === INBOX_EMAIL_TYPE}
      filename={document.linkSubject}
      newValue={newValue}
      oldValue={oldValue}
    />
  ),
  modified: ({
    id,
    document,
    title,
    isDeleted,
    old: oldValue,
    new: newValue,
    activity,
    onClickFile,
  }) => (
    <ModifiedItem
      key={id}
      isDeleted={isDeleted}
      filename={document.origin}
      newValue={newValue}
      title={title}
      oldValue={oldValue}
      onClickFile={onClickFile}
      activity={activity}
    />
  ),
  archived: ({ id, title, document, isDeleted, onClickFile }) => (
    <ArchiveableItem
      key={id}
      isDeleted={isDeleted}
      actionTypeLabel={title}
      filename={document.origin}
      onClickFile={onClickFile}
    />
  ),
  duplicated: ({ id, document, isDeleted }) => (
    <ArchiveableItem
      key={id}
      isDeleted={isDeleted}
      actionTypeLabel="created a duplicate file "
      filename={document.origin}
    />
  ),
  starred: ({ id, document, title, isDeleted, old: oldValue, new: newValue }) => (
    <StarredItem
      key={id}
      isDeleted={isDeleted}
      actionTypeLabel={title}
      filename={document.origin}
      hasDocument={Object.keys(document).length > 0}
      newValue={newValue}
      oldValue={oldValue}
      title={title}
    />
  ),
  clone: ({ id, document, isDeleted, onClickFile }) => (
    <ArchiveableItem
      key={id}
      isDeleted={isDeleted}
      actionTypeLabel="duplicated this file "
      filename={document.origin}
      onClickFile={onClickFile}
    />
  ),
  granted: ({ id, document, title, isDeleted, new: newValue }) => (
    <DisplayNewItem
      key={id}
      isDeleted={isDeleted}
      actionTypeLabel={title}
      filename={document.origin}
      newValue={newValue}
    />
  ),
  removed: ({ id, document, title, isDeleted, new: newValue }) => (
    <DisplayNewItem
      key={id}
      isDeleted={isDeleted}
      actionTypeLabel={title}
      filename={document.origin}
      newValue={newValue}
    />
  ),
  download: ({ id, document, isDeleted, onClickFile }) => (
    <ArchiveableItem
      key={id}
      isDeleted={isDeleted}
      actionTypeLabel="downloaded a file "
      filename={document.origin}
      onClickFile={onClickFile}
    />
  ),
  marked: ({ id, title, isDeleted, document, activity, linkType }) => (
    <MarkedItem
      key={id}
      isDeleted={isDeleted}
      activity={activity}
      linkType={linkType}
      linkSubject={document.linkSubject}
      action={'marked'}
      actionTypeLabel={`${title}`}
      filename={document.origin}
    />
  ),
  published: ({ id, title, document }) => (
    <React.Fragment key={id}>
      <AnchorActivityItem actionTypeLabel={'published'} filename={document.origin} />
      <span> {title} </span>
    </React.Fragment>
  ),
};
